import { render } from "./ContactEditComponent.vue?vue&type=template&id=6a488a92"
import script from "./ContactEditComponent.vue?vue&type=script&lang=js"
export * from "./ContactEditComponent.vue?vue&type=script&lang=js"

import "./ContactEditComponent.vue?vue&type=style&index=0&id=6a488a92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__